// Registro mínimo del lease de mesa ACTUAL de este dispositivo.
//
// Vive aparte del manager para que `utils/axios.js` pueda leerlo sin
// importar el store ni el propio axios (evita dependencias circulares).
//   - El manager (mesaLeaseManager) lo actualiza al adquirir/soltar.
//   - El interceptor de axios añade `X-Mesa-Lease` en las mutaciones.
//   - El interceptor de errores avisa al manager si el servidor responde
//     409 LEASE_HELD (otro dispositivo tiene la mesa).

let current = null; // { mesaId, leaseId, mode }
let leaseHeldHandler = null;

export const getCurrentLease = () => current;

export function setCurrentLease(lease) {
  current = lease && lease.leaseId ? { ...lease } : null;
}

export function clearCurrentLease(mesaId) {
  if (!mesaId || current?.mesaId === mesaId) current = null;
}

export function setLeaseHeldHandler(fn) {
  leaseHeldHandler = typeof fn === "function" ? fn : null;
}

export function notifyLeaseHeld(info) {
  try {
    leaseHeldHandler?.(info);
  } catch {
    /* nunca romper la request por esto */
  }
}
